import React, { useState, useEffect, useRef } from 'react';
import axios from '../../../lib/axios'
import errorHandler from "../../../helpers/errorHandler";
import Modal from 'react-bootstrap/Modal';
import { numberToDateString } from "../../../helpers/numberToDateString";
import EnrolledProgramDetailProgramComp from './detailProgram';

const TableProgramTerdaftarComp = () => {

    const [showDetailProgram, setShowDetailProgram] = useState(false);

    const [search, setSearch] = useState("")
    const [transactionItem, setTransactionItem] = useState(null)
    const [transactionItems, setTransactionItems] = useState([])
    const [currentPage, setCurrentPage] = useState(1)
    const [totalPages, setTotalPages] = useState(1)
    const [totalItems, setTotalItems] = useState(0)

    const fetchData = async (page = 1, keyword = "") => {
        try {
            const options = {
                url: `/users/programs/enrolled?page=${page}&search=${encodeURIComponent(keyword)}`,
                method: 'GET',
                headers: { Authorization: `Bearer ${localStorage.getItem('access_token')}` }
            }
            const { data } = await axios(options)
            setTransactionItems(data.data.transactionItems)
            setTotalPages(data.data.totalPages || 1)
            setTotalItems(data.data.totalItems || 0)

        } catch (err) {
            errorHandler({ err: err?.response?.data || err })
        }
    }

    const handleChangeSearch = (text) => {
        setSearch(text)
    }

    const handlePageChange = (pageNumber) => {
        if (pageNumber < 1 || pageNumber > totalPages) return
        setCurrentPage(pageNumber)
        fetchData(pageNumber, search)
    }

    const handleShowDetail = (transactionItem) => {
        setTransactionItem(transactionItem)
        setShowDetailProgram(true)
    }

    const isFirstRender = useRef(true)

    useEffect(() => {
        fetchData(1, "")
    }, [])

    // Debounce: kirim pencarian ke server & reset ke halaman 1
    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false
            return
        }
        const timer = setTimeout(() => {
            setCurrentPage(1)
            fetchData(1, search)
        }, 500)
        return () => clearTimeout(timer)
        // eslint-disable-next-line
    }, [search])

    return (
        <>
            <div className="card" style={{
                backgroundColor: '#F2F2F2',
            }}>
                <div className="card-body">
                    <div className="col-lg-3 col-12 mb-3">
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Cari Program Terdaftar"
                            value={search}
                            onChange={(e) => handleChangeSearch(e.target.value)}
                        />
                    </div>
                    <div className="table-responsive">
                        <table className="table mb-3">
                            <tr>
                                <th>NAMA PROGRAM</th>
                                <th className="text-center">JADWAL</th>
                                <th className="text-center">ACTION</th>
                            </tr>
                            <tbody>
                                {transactionItems.length > 0 ? (
                                    transactionItems.map((row, index) => (
                                        <tr key={index}>
                                            <td style={{ fontSize: '16px' }}>
                                                {row.Schedule.Program.name}
                                            </td>
                                            <td className="text-center" style={{ fontSize: '16px' }}>
                                                {numberToDateString(row.Schedule.startDate)} s/d {numberToDateString(row.Schedule.endDate)}
                                            </td>
                                            <td className="text-center">
                                                <button
                                                    onClick={() => handleShowDetail(row)}
                                                    className="btn"
                                                    style={{ backgroundColor: '#26D07C', color: '#F2F2F2' }}
                                                >
                                                    Detail Program
                                                </button>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan={3} className="text-center">
                                            Tidak ada program
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                    <div className="d-flex flex-wrap justify-content-between align-items-center mt-3">
                        <span className="text-muted">
                            {totalItems > 0
                                ? `Menampilkan halaman ${currentPage} dari ${totalPages} (total ${totalItems} program)`
                                : "Tidak ada program"}
                        </span>

                        <nav aria-label="Navigasi halaman program terdaftar">
                            <ul className="pagination mb-0">
                                <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                                    <button
                                        className="page-link"
                                        onClick={() => handlePageChange(currentPage - 1)}
                                        disabled={currentPage === 1}
                                        style={{ fontWeight: "500" }}
                                    >
                                        Previous
                                    </button>
                                </li>

                                {Array.from({ length: totalPages }, (_, i) => i + 1).map(
                                    (pageNumber) => (
                                        <li
                                            key={pageNumber}
                                            className={`page-item ${currentPage === pageNumber ? "active" : ""}`}
                                        >
                                            <button
                                                className="page-link"
                                                onClick={() => handlePageChange(pageNumber)}
                                                style={{ fontWeight: "500" }}
                                            >
                                                {pageNumber}
                                            </button>
                                        </li>
                                    )
                                )}

                                <li className={`page-item ${currentPage >= totalPages ? "disabled" : ""}`}>
                                    <button
                                        className="page-link"
                                        onClick={() => handlePageChange(currentPage + 1)}
                                        disabled={currentPage >= totalPages}
                                        style={{ fontWeight: "500" }}
                                    >
                                        Next
                                    </button>
                                </li>
                            </ul>
                        </nav>
                    </div>
                </div>
            </div>

            <Modal
                show={showDetailProgram}
                size='xl'
                onHide={() => setShowDetailProgram(false)}
                backdrop="static"
                keyboard={false}

            >
                <Modal.Header
                    closeButton
                >
                    <Modal.Title className='ms-auto' style={{ margin: 'auto', textAlign: 'center' }}>
                        <div className='mt-3 mb-3'>
                            <h2 className='mb-1'>Detail Informasi Program</h2>
                        </div>
                    </Modal.Title>
                </Modal.Header >
                <Modal.Body
                    style={{ backgroundColor: '#FFFFFF' }}
                >
                    <EnrolledProgramDetailProgramComp
                        transactionItems={transactionItem ? [transactionItem] : []}
                    />
                </Modal.Body>
            </Modal>
        </>
    )
}

export default TableProgramTerdaftarComp
